import React from "react";
import { ListChecks, Repeat, SlidersHorizontal, Wand2 } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "../ui/popover";
import { Switch } from "../ui/switch";
import { useCredits } from "../../context/CreditsContext";

const Row = ({ icon: Icon, title, desc, checked, onChange, disabled, testid }) => (
  <label className={`flex items-start gap-3 p-3 rounded-xl transition-colors ${disabled ? "opacity-50" : "hover:bg-slate-50 cursor-pointer"}`}>
    <Icon size={16} className="mt-0.5 text-sky-600" />
    <span className="flex-1">
      <span className="block text-sm font-medium text-slate-900">{title}</span>
      <span className="block text-xs text-slate-500 leading-snug">{desc}</span>
    </span>
    <Switch checked={checked} onCheckedChange={onChange} disabled={disabled} data-testid={testid} className="mt-0.5 data-[state=checked]:bg-sky-500" />
  </label>
);

// plan: this message; always/onAlways (workspace only): project-wide "always plan first"
export const BuildSettings = ({ plan, setPlan, ai, setAi, planLocked, always, onAlways, testid, align = "end" }) => {
  const { pricing } = useCredits();
  const active = plan || ai;
  const togglePlan = (v) => { setPlan(v); if (!v && always) onAlways(false); };
  const toggleAlways = (v) => { onAlways(v); if (v) setPlan(true); };
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid} aria-label="Build settings" title="Build settings"
          className={`relative w-9 h-9 shrink-0 rounded-full flex items-center justify-center transition-colors ${active ? "text-sky-600 bg-sky-50" : "text-slate-600 hover:bg-slate-100"}`}>
          <SlidersHorizontal size={18} strokeWidth={1.8} />
          {active && <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 rounded-full bg-sky-500" />}
        </button>
      </PopoverTrigger>
      <PopoverContent align={align} className="w-80 p-2 rounded-2xl bg-white border-slate-200 shadow-xl" data-testid={`${testid}-panel`}>
        <p className="px-3 pt-2 pb-1 text-[11px] font-semibold uppercase tracking-wider text-slate-400">Before building</p>
        <Row icon={ListChecks} title="Plan first" desc={planLocked ? "Brainstorm always starts with a plan" : `AI shares a plan and asks questions before coding · ${pricing.plan} credit`}
          checked={plan} onChange={togglePlan} disabled={planLocked} testid={`${testid}-plan-switch`} />
        {onAlways && (
          <Row icon={Repeat} title="Always plan first" desc="Every message in this project starts with a plan"
            checked={!!always} onChange={toggleAlways} testid={`${testid}-always-switch`} />
        )}
        <Row icon={Wand2} title="AI images" desc={`Creates up to 3 custom images for your app · up to ${pricing.images} credits, unused refunded`}
          checked={ai && !plan} onChange={setAi} disabled={plan} testid={`${testid}-ai-images-switch`} />
        {plan && <p className="px-3 pb-2 text-[11px] text-slate-400">AI images can be switched on when you approve the plan.</p>}
      </PopoverContent>
    </Popover>
  );
};

export default BuildSettings;
